export const STATUS_VARIANTS = {
  pending: 'PENDING',
  completed: 'COMPLETED',
  rejected: 'REJECTED',
};
